<template>
  <div class="container">
    <div class="font_1">
        探索 - <span class="font_2">推荐课程</span>
    </div>

    <div class="font_3">
        “每一堂课都是一次对自我的挑战，一次对知识的追求，选择我们，选择了成长，选择了未来。”
    </div>

    <div>
        <el-row :gutter="20">
            <el-col :span="6" v-for="course in courseHotList" :key="course.courseId" @click="hrefCourse(course.courseId);">
                <el-card style="max-width: 480px;" class="courseCard no-padding"> 
                <img :src="course.courseImg" style="width: 100%; height: 150px;"/>
                    <template #footer>
                    <h6 style="font-weight:bold">{{ course.courseName }}</h6>
                    <div>
                        <img src="@/assets/img/card/Recommend.png" class="recommendImg"/>
                        <span class="font_4">推荐值: {{ (course.isHot / 20).toFixed(1) }}</span>
                    </div>
                
                    <hr style="margin: 0px">
                    <span class="overlay-text-public" v-if="course.isPublic == 0">公开课</span>  
                    <span class="overlay-text-private" v-if="course.isPublic == 1">私有课</span>  
                    <span class="courseCardFont">主讲人:{{ course.teacher.nickName }}</span>    
                </template> 
                </el-card>
            </el-col>
        </el-row>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import $ from "jquery";
import {ElMessage} from 'element-plus'

const courseHotList = ref([]);


onMounted(() => {
  getCourse();
});


const getCourse = () => {
  $.ajax({
    url: "http://124.222.105.205:5000/get/api/course/getHotCourse",
    type: "post",
    success(resp) {
        if (resp.code == "200") {
            courseHotList.value = resp.data;
        } else {
            ElMessage({
                type: "error",
                message: resp.msg,
            });
        }
    },
    error() {
    ElMessage({
            type: "error",
            message: "后台异常!",
        });
    },
  });
};

const hrefCourse = (id) => {
  const a = document.createElement('a');
  a.href = `/CourseDetail/${id}`; // 假设课程详情页面的路由是/course/:courseId
  a.target = '_blank'; // 在新页面中打开
  a.click(); // 触发点击事件
}

</script>

<style scoped>
.font_1{
    padding-top: 60px;
    font-weight: 550;
    font-size: 40px;
}

.font_2 {
    color: rgb(113, 20, 219);
    text-decoration: underline;
    text-decoration-color: rgb(255, 140, 8);
    font-size: 30px;
    text-underline-offset: 5px;
}

.font_3 {
    margin: 20px 0px;
    color: rgb(100, 100, 100);
    font-size: 15px;
}


.font_4 {
    color: rgb(100, 100, 100);
    margin: 10px 0px;
}

.courseCard {
  border-radius: 20px;
  margin: 20px 0px;
  padding: 0px;
  transition: transform 0.4s; /* 添加过渡效果 */
}

.recommendImg {
    width: 15px;
}

.courseCard:hover{
     cursor: pointer;
     transform: translateY(-10px); /* 在hover时向上移动5像素 */
    transition: 400ms;
    box-shadow: 12px 5px 5px rgb(164, 164, 164);
}

.courseCardFont{
  font-size: xx-small;
  color: gray;
  float: right;
}

.overlay-text-public {
    width: auto; /* Adjust width based on content */
    padding: 5px; /* Add padding for better appearance */
    background-color: rgba(255, 218, 163, 0.97); /* Set background color and opacity */
    font-size: 8px; /* Decrease font size */
    color: rgb(0, 0, 0); /* Set text color */
    border-radius: 5%; /* Add border radius for rounded corners */
}

.overlay-text-private {
    width: auto; /* Adjust width based on content */
    padding: 5px; /* Add padding for better appearance */
    background-color: rgba(230, 179, 245, 0.97); /* Set background color and opacity */
    font-size: 8px; /* Decrease font size */
    color: rgb(255, 255, 255); /* Set text color */
    border-radius: 5%; /* Add border radius for rounded corners */
}

/deep/ .el-card__body{
    padding: 0px;
  }
</style>